export const rdWidgetFooter = {
  requires: '^rdWidget',
  transclude: true,
  template: `
    <div class="widget-footer" ng-transclude></div>
  `,
};
